import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Simple Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="text-teal-600 hover:text-teal-700 font-semibold flex items-center cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line mr-2"></i>
            Retour à l'accueil
          </Link>
        </div>
      </header>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 text-center">
              Politique de <strong className="text-teal-600">Confidentialité</strong>
            </h1>
            
            <div className="bg-gray-50 rounded-lg p-8 space-y-8">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">1. Responsable du traitement des données</h3>
                <p className="text-gray-700 leading-relaxed mb-2">
                  <strong>DFPRO SAS</strong>
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  Adresse : 100 Route de Nîmes – 30132 Caissargues
                </p>
                <p className="text-gray-700 leading-relaxed mb-2">
                  Email : info@dfpro.fr
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Téléphone : 04.65.84.88.50
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">2. Données collectées</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Nous collectons les données personnelles suivantes lorsque vous utilisez notre site :
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><strong>Données d'identité :</strong> nom, prénom</li>
                  <li><strong>Données de contact :</strong> adresse email, numéro de téléphone</li>
                  <li><strong>Données de demande :</strong> type de service souhaité, message</li>
                  <li><strong>Données de navigation :</strong> adresse IP, cookies, pages visitées</li>
                </ul>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">3. Finalités du traitement</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Vos données personnelles sont collectées pour les finalités suivantes :
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Traiter vos demandes de devis et de contact</li>
                  <li>Vous recontacter pour répondre à vos questions</li>
                  <li>Gérer la relation client et le suivi des interventions</li>
                  <li>Améliorer nos services et l'expérience utilisateur</li>
                  <li>Respecter nos obligations légales et réglementaires</li>
                  <li>Réaliser des statistiques de visite (données anonymisées)</li>
                </ul>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">4. Base légale du traitement</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Le traitement de vos données repose sur :
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><strong>Votre consentement :</strong> lors de l'envoi du formulaire de contact</li>
                  <li><strong>L'exécution du contrat :</strong> pour la réalisation des prestations demandées</li>
                  <li><strong>L'intérêt légitime :</strong> pour l'amélioration de nos services</li>
                  <li><strong>Les obligations légales :</strong> conservation des données comptables et fiscales</li>
                </ul>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">5. Durée de conservation</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Vos données personnelles sont conservées pendant les durées suivantes :
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><strong>Demandes de devis :</strong> 3 ans à compter de la demande</li>
                  <li><strong>Clients :</strong> 10 ans après la fin de la relation contractuelle (obligations comptables)</li>
                  <li><strong>Prospects :</strong> 3 ans à compter du dernier contact</li>
                  <li><strong>Cookies :</strong> 13 mois maximum</li>
                </ul>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">6. Destinataires des données</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Vos données personnelles sont destinées aux personnes suivantes :
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Personnel habilité de DFPRO SAS</li>
                  <li>Sous-traitants techniques (hébergement, maintenance)</li>
                  <li>Partenaires pour la réalisation des prestations</li>
                  <li>Autorités légales sur demande judiciaire</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-4">
                  Vos données ne sont jamais vendues à des tiers à des fins commerciales.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">7. Vos droits</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Conformément au RGPD, vous disposez des droits suivants :
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><strong>Droit d'accès :</strong> obtenir une copie de vos données personnelles</li>
                  <li><strong>Droit de rectification :</strong> corriger vos données inexactes ou incomplètes</li>
                  <li><strong>Droit à l'effacement :</strong> supprimer vos données dans certains cas</li>
                  <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
                  <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
                  <li><strong>Droit à la portabilité :</strong> récupérer vos données dans un format structuré</li>
                  <li><strong>Droit de retirer votre consentement :</strong> à tout moment</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-4">
                  Pour exercer vos droits, contactez-nous à : <strong>info@dfpro.fr</strong>
                </p>
                <p className="text-gray-700 leading-relaxed mt-2">
                  Vous disposez également du droit d'introduire une réclamation auprès de la CNIL : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline cursor-pointer">www.cnil.fr</a>
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">8. Sécurité des données</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre :
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>La destruction accidentelle ou illicite</li>
                  <li>La perte accidentelle</li>
                  <li>L'altération, la diffusion ou l'accès non autorisé</li>
                  <li>Toute autre forme de traitement illicite</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-4">
                  Nos mesures incluent : chiffrement SSL, sauvegardes régulières, accès restreints, hébergement sécurisé.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">9. Cookies et traceurs</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Notre site utilise des cookies pour améliorer votre expérience. Pour plus d'informations, consultez notre <Link to="/politique-cookies" className="text-teal-600 hover:underline cursor-pointer">Politique de Cookies</Link>.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">10. Transfert de données hors UE</h3>
                <p className="text-gray-700 leading-relaxed">
                  Vos données personnelles sont hébergées au sein de l'Union Européenne et ne font l'objet d'aucun transfert hors UE.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">11. Modifications</h3>
                <p className="text-gray-700 leading-relaxed">
                  Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. La version en vigueur est celle publiée sur le site. Date de dernière mise à jour : <strong>20/11/2025</strong>
                </p>
              </div>

              <div className="bg-teal-50 border-l-4 border-teal-600 p-6 mt-8">
                <h4 className="text-xl font-bold text-gray-900 mb-3">Contact RGPD</h4>
                <p className="text-gray-700 leading-relaxed mb-2">
                  Pour toute question relative à la protection de vos données personnelles :
                </p>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Email :</strong> info@dfpro.fr<br />
                  <strong>Téléphone :</strong> 04.65.84.88.50<br />
                  <strong>Courrier :</strong> DFPRO SAS - 100 Route de Nîmes – 30132 Caissargues
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PolitiqueConfidentialite;
